<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <h1>Nieuws</h1>
      </b-col>

      <b-col lg="4" md="6" cols="12" class="mt-4">
        <b-card header="Nieuwe functionaliteit">
          <page-snippet name="new-functionality" class="" />
        </b-card>
      </b-col>

      <b-col lg="4" md="6" cols="12" class="mt-4">
        <b-card header="Toekomstige functionaliteit">
          <page-snippet name="roadmap" class="" />
        </b-card>
      </b-col>

      <b-col lg="4" md="6" cols="6" class="mt-4">
        <TrendList :trendFilter="trendFilter" :perPage="25" aggName="tracks" title="Top Tracks" subTitle="Streams afgelopen 7 dagen" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'News',
    components: {
      'page-snippet': () => import('@/components/PageSnippet'),
    },
    props: {
    },
    mounted () {
    }
  }
</script>